import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthPageLayout from "../../components/authPageLayout/AuthPageLayout";
import useAuthStore from "../../store/authStore";
import { Text } from "../../components/catalyst/text";
import { Button } from "../../components/catalyst/button";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const { error } = useAuthStore();

  const { updatePassword, isBusyAuthenticating } = useAuthStore();

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    try {
      const res = await updatePassword(token, email, password);
      setIsSuccess(res);
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  const handleOkClick = () => {
    navigate("/login");
  };

  return (
    <AuthPageLayout isBusy={isBusyAuthenticating}>
      <div className="relative z-10 flex flex-col items-center w-full max-w-md p-4 mx-auto mt-20 mb-8 flex-grow">
        <div className="flex-grow flex flex-col w-full overflow-hidden">
          <div className="flex-grow flex flex-col overflow-y-auto max-h-[calc(100vh-8rem)]">
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold text-white dark:text-gray-200 mb-4 md:text-3xl">
                Reset Password
              </h1>
              <p className="text-base text-gray-600 dark:text-gray-300 mt-2 md:mt-4 md:text-lg">
                Join the League and swing into action
                <br className="hidden md:inline" />
                Your golf journey starts here!
              </p>
            </div>
            {isSuccess ? (
              <div className="w-full max-w-md bg-white bg-opacity-80 p-8 rounded-lg shadow-lg mt-8 dark:bg-gray-800">
                <div className="text-gray-500 text-center text-sm leading-7">
                  <p>
                    Password has been successfully reset. Proceed to sign in and
                    use the new password.
                  </p>
                  <button
                    onClick={handleOkClick}
                    className="flex w-full mt-6 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600"
                  >
                    Ok
                  </button>
                </div>
                <p className="mt-10 text-center text-sm text-gray-500">
                  Not a member?{" "}
                  <a
                    href="/register"
                    className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
                  >
                    Register
                  </a>
                </p>
              </div>
            ) : (
              <div className="w-full max-w-md bg-white bg-opacity-80 p-8 rounded-lg shadow-lg mt-8 dark:bg-gray-800">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-600 dark:text-gray-300"
                    >
                      Email
                    </label>
                    <div className="mt-1">
                      <input
                        id="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                        placeholder="Enter Email"
                        required
                        className="block w-full p-2 rounded-md border border-gray-300 bg-white text-gray-900 dark:text-gray-100 dark:bg-gray-700 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-gray-600 dark:text-gray-300"
                    >
                      Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                        placeholder="Password"
                        required
                        className="block w-full p-2 rounded-md border border-gray-300 bg-white text-gray-900 dark:text-gray-100 dark:bg-gray-700 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="confirmPassword"
                      className="block text-sm font-medium text-gray-600 dark:text-gray-300"
                    >
                      Confirm Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="confirmPassword"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                        placeholder="Confirm Password"
                        required
                        className="block w-full p-2 rounded-md border border-gray-300 bg-white text-gray-900 dark:text-gray-100 dark:bg-gray-700 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>

                  {password !== confirmPassword && (
                    <Text className="text-center">
                      Passwords do not match!
                    </Text>
                  )}

                  <div>
                    <Button
                      type="submit"
                      color="blue"
                      className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600"
                      disabled={
                        password !== confirmPassword ||
                        !password ||
                        !email ||
                        !confirmPassword
                      }
                    >
                      Reset
                    </Button>
                  </div>
                  <div className="text-center">
                    {error && <Text>{error}</Text>}
                  </div>
                  <div className="mt-10  flex items-center justify-center gap-4 text-sm">
                    <a
                      href="/login"
                      className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
                    >
                      Login here
                    </a>

                    <Text> | </Text>
                    <div className="flex items-center gap-1">
                      <Text>Not a member?</Text>
                      <a
                        href="/register"
                        className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
                      >
                        Register
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </AuthPageLayout>
  );
};

export default ResetPassword;
